class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  /* 9/28/26 — "cart not loading" fixes:
     1. The cart-drawer element kept its "is-empty" class when the first item was added
        by the pop-ups / vehicle page / suggestion rows (only the theme's own product form
        removed it), so the drawer opened without its "Your Cart" header and free-shipping bar.
        The class now always follows what was just rendered.
     2. If Shopify sends the add-to-cart answer without the drawer HTML (it can, when a
        section is slow to render), the old code crashed and the drawer never opened.
        Now it fetches the drawer on its own; if even that fails it goes to the cart page. */
  renderContents(parsedState) {
    this.productId = parsedState && parsedState.id;
    const sections = (parsedState && parsedState.sections) || {};
    const missing = this.getSectionsToRender().some((s) => !sections[s.id]);
    if (missing) {
      this.refreshDrawer(true);
      return;
    }
    try {
      this.applySections(sections);
    } catch (e) {
      console.error(e);
      this.refreshDrawer(true);
      return;
    }
    setTimeout(() => this.open());
  }

  applySections(sections) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        sections[section.id],
        section.selector
      );
    });
    this.syncEmptyState();
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay.dataset.cdxBound) {
      overlay.dataset.cdxBound = '1';
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  syncEmptyState() {
    const empty = !!this.querySelector('.drawer__inner-empty');
    this.classList.toggle('is-empty', empty);
    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }

  refreshDrawer(openAfter) {
    const ids = this.getSectionsToRender().map((s) => s.id).join(',');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(`${root}?sections=${ids}`)
      .then((r) => {
        if (!r.ok) throw new Error('sections ' + r.status);
        return r.json();
      })
      .then((sections) => {
        this.applySections(sections);
        if (openAfter) this.open();
      })
      .catch(() => {
        if (openAfter) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// Mobile swipe-to-close: drag the cart drawer to the right to dismiss (pairs with the KYFE-style handle in cart-drawer-light.css)
(function(){function initCartSwipe(){var cd=document.querySelector('cart-drawer');if(!cd||cd.dataset.swipeClose)return;cd.dataset.swipeClose='1';var sx=0,sy=0,dx=0,drag=false,lock=false;function pane(){return cd.querySelector('.drawer__inner');}cd.addEventListener('touchstart',function(e){if(window.innerWidth>749)return;if(e.target.closest('.cdxr-wrap,button,input,a,summary'))return;if(!e.target.closest('.drawer__inner'))return;sx=e.touches[0].clientX;sy=e.touches[0].clientY;dx=0;drag=true;lock=false;},{passive:true});cd.addEventListener('touchmove',function(e){if(!drag)return;var el=pane();if(!el)return;var mx=e.touches[0].clientX-sx;var my=e.touches[0].clientY-sy;if(!lock){if(Math.abs(mx)>12&&Math.abs(mx)>Math.abs(my)*1.4){lock=true;el.style.transition='none';}else if(Math.abs(my)>12){drag=false;return;}}if(lock){dx=Math.max(0,mx);el.style.transform='translateX('+dx+'px)';}},{passive:true});cd.addEventListener('touchend',function(){if(!drag)return;drag=false;var el=pane();if(el){el.style.transition='';el.style.transform='';}if(lock&&dx>80){if(typeof cd.close==='function'){cd.close();}else{cd.classList.remove('active');document.body.classList.remove('overflow-hidden');}}lock=false;});}initCartSwipe();document.addEventListener('DOMContentLoaded',initCartSwipe);})();
